import React from 'react';
import { SignIn } from '../auth/clerk';
import { useTheme } from '../context/ThemeContext';
import Wordmark from '../components/Brand/Wordmark';

/**
 * Sign-in page using Clerk's SignIn component.
 */
function SignInPage() {
  const { theme } = useTheme();

  return (
    <div className={`auth-page ${theme}`}>
      <div className="auth-container">
        <div className="auth-header">
          <h1 className="auth-wordmark-heading">
            <Wordmark placement="auth" className="auth-wordmark" />
          </h1>
          <p className="auth-invite-note">Beta is invite-only. If you were sent an invitation, use it to create your account.</p>
        </div>
        <SignIn
          routing="path"
          path="/sign-in"
          signUpUrl="/sign-up"
          fallbackRedirectUrl="/projects"
          signUpForceRedirectUrl="/projects"
          signUpFallbackRedirectUrl="/projects"
          appearance={{
            elements: {
              rootBox: 'clerk-root-box',
              card: 'clerk-card',
            }
          }}
        />
      </div>
    </div>
  );
}

export default SignInPage;
